import { Input } from "native-base";

export const TextboxCustom = (props) => {
  var disable_style = { backgroundColor: "custom.grey.14", borderColor: "custom.grey.8", color: "custom.grey.4", opacity: "1", placeholderTextColor: "custom.grey.6" };
  var dark_style = { backgroundColor: "white", fontWeight: "300", border:"1px solid red" };
  var style = { fontFamily: "Inter", fontSize: "14px", paddingTop: "12px", marginTop: "-5px" }
  var important_style = { borderColor: "custom.grey.2", borderRadius: "4px" }
  
  if (props.new_style) {
    for (var property in props.new_style) {
      style[property] = props.new_style[property];
    }
  }

  if (props.input_disable_style) {
    for (var property_2 in props.input_disable_style) {
      disable_style[property_2] = props.input_disable_style[property_2];
    }
  }

  if (props.dark_style) {
    for (var property_3 in props.dark_style) {
      dark_style[property_3] = props.dark_style[property_3];
    }
  }

  if (props.important_style) {
    for (var property_4 in props.important_style) {
      important_style[property_4] = props.important_style[property_4];
    }
  }

  return (
    <Input style={style}
      color="custom.grey.4" h="40px"
      _important={important_style}
      _dark={dark_style}
      placeholderTextColor="custom.grey.6"
      focusOutlineColor="custom.grey.100"
      inValidOutlineColor="custom.red.1"
      _invalid={{ backgroundColor: "custom.red.2" }}
      _disabled={disable_style}
      // rightOutlineColor="red.500"
      {...props}
    />
  );
};